// https://app.growthbook.io/features/pen-4993_v2
export const GLOBAL_TEST_PURCHASE_CTA_COPY_EXPERIMENT_NAME = 'pen-4993_v2'
